import React from "react";
import './Carousel.css'

const Carousel = () => {
  return (
    <div>
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item parent active">
            <img src="https://i.ibb.co/rsK4G30/life-style-1.jpg" className="cus-image-resize" alt="..." />
            <div className="carousel-caption mb-3 d-none d-md-block">
              <h1>Life Needs More Getaways</h1>
              <p>Receive exclusive benefits when you stay overnight at the Cedar Point Resorts.</p>
            </div>
          </div>
          <div className="carousel-item parent">
            <img src="https://cdn-cloudfront.cfauthx.com/binaries/content/gallery/cp-en-us/banners/play/events/cp-cedar-point-nights-v2-banner.jpg" className="d-block w-100 img-resize black-overlay" alt="..." />
            <div className="carousel-caption mb-3 d-none d-md-block">
              <h1>The Exclusive Benefits are Right Next Door</h1>
              <p>Receive exclusive benefits when you stay overnight at the Cedar Point Resorts.</p>
            </div>
          </div>
          <div className="carousel-item parent">
            <img src="https://cdn-cloudfront.cfauthx.com/binaries/content/gallery/cp-en-us/banners/cp-steelvengeance-bannerv2.jpg" className="d-block w-100 img-resize black-overlay" alt="..." />
            <div className="carousel-caption mb-3 d-none d-md-block">
              <h1>Your HalloWeekends Host Hotels</h1>
              <p>Receive exclusive benefits when you stay overnight at the Cedar Point Resorts.</p>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Carousel;
